<micro-select-combo #sel
              placeholder="Sprint"
              [valueCallback]="valueCallback"
              [mode]="mode"
              [(id)]="taskSprintId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="isDisabled()"
              [requires]="requires()"
>
</micro-select-combo>
